// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import type { ValidationRules } from "@lg/shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { ProxyTargetSymbol } from "@lg/shared/for-apps";
import { Semaphore } from "@lg/shared/for-apps";
import { memoize } from "@lg/shared/for-apps";
import { NgSharedModule } from "@lg/ng-shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";
import { GenericTableComponent } from "@lg/ng-shared";
import { MatTableModule } from "@angular/material/table";
import { RouterLink } from "@angular/router";

interface Properties {
    vendorId: This.Vendor.Id;
    referenceRequest: This.CustomerRequest;
    referenceMaterials: string[];
    referenceProcessingMethods: This.ProcessingMethod.Id[];
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Orders-VendorHistoryInclude',
    templateUrl: './VendorHistoryInclude.html',
    styleUrls: ['./VendorHistoryInclude.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgSharedModule,
        GenericTableComponent,
        MatTableModule,
        RouterLink
    ],
})
export class VendorHistoryInclude extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Orders.VendorHistoryInclude';
    $isDialog = false;
    $Modules = $Modules;
    Orders = Orders;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    _DataTableBlock_columns_5 = (screen: Properties) => ['request.id', 'request.date', 'item.requestItem.materials.name', 'item.reuestItem.processingMethod', 'Offered quantities'];
    $validators: Record<number, ValidationRules> = {

    };
    input_vendorId = input(undefined, { alias: 'vendorId' });
    var_vendorId = proxySignal<This.Vendor.Id>(undefined as any);
    input_referenceRequest = input(undefined, { alias: 'referenceRequest' });
    var_referenceRequest = proxySignal<This.CustomerRequest>(undefined as any);
    var_referenceMaterials = proxySignal<string[]>(undefined as any);
    var_referenceProcessingMethods = proxySignal<This.ProcessingMethod.Id[]>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get vendorId() { return component.var_vendorId() },
                set vendorId(value: This.Vendor.Id) { component.var_vendorId.set(value) },
                get referenceRequest() { return component.var_referenceRequest() },
                set referenceRequest(value: This.CustomerRequest) { component.var_referenceRequest.set(value) },
                get referenceMaterials() { return component.var_referenceMaterials() },
                set referenceMaterials(value: string[]) { component.var_referenceMaterials.set(value) },
                get referenceProcessingMethods() { return component.var_referenceProcessingMethods() },
                set referenceProcessingMethods(value: This.ProcessingMethod.Id[]) { component.var_referenceProcessingMethods.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            vendorId: this.screen.vendorId,
            referenceRequest: this.screen.referenceRequest
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_vendorId = this.dialogData?.data?.vendorId ?? this.input_vendorId() ?? (undefined)
            if (new_vendorId !== undefined) this.screen.vendorId = new_vendorId


            const new_referenceRequest = this.dialogData?.data?.referenceRequest ?? this.input_referenceRequest() ?? (undefined)
            if (new_referenceRequest !== undefined) this.screen.referenceRequest = new_referenceRequest

            if (!isVariablesInitialized) this.screen.referenceMaterials = ([])
            if (!isVariablesInitialized) this.screen.referenceProcessingMethods = ([])
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    _DataTableBlock_additionalFindOptions_5($scope: any): any {
        let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}

        return ({
            where: {
                offer: {
                    vendor$id: screen.vendorId,
                },
            },
            relations: {
                offer: true,
                requestItem: {
                    materials: true
                },
                quantities: true,
            }
        })
    }

    _DataTableColumnBlock_cellText_14($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, itemIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: Orders.VendorOfferItem, itemIndex: number } = $scope ?? {}

        return (Sys.Date.format(item.offer.receivedOn, 'dd.MM.yyyy'))
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            if (screen.referenceRequest) {
                screen.referenceMaterials = screen.referenceRequest.items.flatMap(i => i.materials).map(m => m.name)
                screen.referenceProcessingMethods = screen.referenceRequest.items.map(i => i.processingMethod.id)
            }

        }
    }
}
